export default __webpack_public_path__ + "static/media/visby-cf-bold.0a2bb14b.ttf";